import React from 'react'
import { render } from 'react-dom'
import { AppContainer } from 'react-hot-loader'

import App from './app'
import legacyAffiliates from '../common/utils/legacyAffiliates'
import configureStore from '../common/store/configureStore'

import '../assets/stylesheets/core.css'
import '../assets/stylesheets/search.css'
import '../assets/stylesheets/style.css'
import '../assets/stylesheets/compontents.css'

// this only runs on initial rendering
const initialState = window.INITIAL_STATE
delete window.INITIAL_STATE

const store = configureStore(initialState)

legacyAffiliates(window.location)

render((
  <AppContainer>
    <App store={store} />
  </AppContainer>
), document.querySelector('#react-view'))

if (module.hot) {
  module.hot.accept('./app', (props) => {
    render((
      <AppContainer>
        <App store={store} />
      </AppContainer>
    ), document.querySelector('#react-view'))
  })
}



// WEBPACK FOOTER //
// ./client/index.js